import { render, staticRenderFns } from "./Nutheader.vue?vue&type=template&id=62d2a81e&scoped=true&"
import script from "./Nutheader.vue?vue&type=script&lang=js&"
export * from "./Nutheader.vue?vue&type=script&lang=js&"
import style0 from "./Nutheader.vue?vue&type=style&index=0&id=62d2a81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2a81e",
  null
  
)

export default component.exports